import React, { useEffect, useState } from "react";
import { Checkbox, Search, Table } from "@veneer/core";
import { Col, Container, Row } from "react-bootstrap";
import Exporttoexcel from "./exporttoexcel";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Loader from "@components/home-page/shared-components/loader/loader";
import Favourite from "./favourite";
import { OnPageLoad_POST } from "services";
import { apiPost } from "@services/service";
import ExportToExcelColor from "./exporttoexcelcolor";
import { AdminNotIndividualRole, ExportMaping } from "utils";

const Recentcases = (props: any) => {
  const [currentPage, setCurrentPage] = React.useState(1);
  const [recentcase, setRecentcase] = React.useState<any[]>([]);
  const [progress, setProgress] = useState<boolean>(false);
  const [isChecked, setIsChecked] = useState(false);
  const [exportXlRow, setExportXlRow] = useState<any>([]);
  const [pageLoad, setPageLoad] = React.useState<any>([]);
  const pagination = [{}];
  const pageSize = 10;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const addloader = () => {
    setProgress(true);
  };
  const resBtn = (data: any) => {
    let uri = `cid=${data.incidentid}`;
    return (
      <button
        className="link"
        onClick={() => {
          navigate(`/edit-case?${uri}`, { state: { data } });
        }}
      >
        {data.hpi_caseid}
      </button>
    );
  };
  React.useEffect(() => {
    if (!pagination) {
      setCurrentPage(1);
    }
  }, [pagination]);

  const userDetails = async () => {
    try {
      const payload = {
        contactid: "85680c15-7814-e711-80fc-5065f38ad971",
        accountid: "f16eeb64-73fc-e611-80fa-5065f38ad971",
        tabid: "RecentCases",
        submittedbyme: false,
        
        
      };
      setProgress(true);
      const res = await apiPost(OnPageLoad_POST, payload);
      if (res.data && res.data.RecentCases) {
        let recentPartOrders = JSON.parse(res.data.RecentCases);
        let fieldMap = {
          "Case ID": "hpi_caseid",
          "Case title": "hpi_subject",
          "Case status": "statuscode",
          "Case Priority": "hpi_casepriority",
          "Submitted By": "hpi_submittedbyid",
          "Serial Number": "productserialnumber",
          "Product Number": "hpi_productnumber",
          "Site-account": "customerid",
          "Internal Tracking number": "hpi_customertrackingnumber",
          "Date submitted": "createdon",
          "Last updated": "modifiedon",
          "statecodeid": "statecodeid",
        };
        let exporteddata = ExportMaping(fieldMap, recentPartOrders);
        setExportXlRow(exporteddata);
        setPageLoad(recentPartOrders);
        setTableFliterData(recentPartOrders);
        setProgress(false);
      } else {
        setProgress(false);
      }
    } catch (error) {
      setProgress(false);
      console.error("Error fetching recent cases:", error);
    }
  };
  useEffect(() => {
    userDetails();
  }, []);
  const handleUpdate = () => {
    setIsChecked(false);
  };
  const setTableFliterData = (matchingcaseGrid: any) => {
    let updatedcases = matchingcaseGrid.map((incident: any) => ({
      ...incident,
      hpi_caseid: resBtn(incident),
      favourite: (
        <Favourite
          caseId={incident.incidentid}
          favourite={incident.favourite}
          pageload={userDetails}
          tableid={"favourite_cases"}
          loader={addloader}
          setIsChecked={handleUpdate}
        />
      ),
    }));
    setRecentcase(updatedcases);
  };

  const handleSearch = (value: string | undefined, field: string) => {
    if (!value) {
      setTableFliterData(pageLoad);
      return;
    }
    let filtered: any;
    if (field === "favourite") {
      filtered = pageLoad.filter((item: any) => {
        return item?.[field]?.toLowerCase()?.includes(value);
      });
    } else {
      setIsChecked(false);
      filtered = pageLoad.filter((item: any) => {
        return item?.[field]
          ?.toLowerCase()
          ?.includes(value.trim().toLowerCase());
      });
    }
    setTableFliterData(filtered);
  };
  const baseTableColumn = [
    {
      id: "hpi_caseid",
      label: t("HPI.MainHomePage.grids.CaseId", { defaultValue: "Case ID" }),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "hpi_caseid")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "hpi_subject",
      label: t("HPI.MainHomePage.grids.casetitle", {
        defaultValue: "Case title",
      }),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "hpi_subject")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "statuscode",
      label: t("HPI.MainHomePage.grids.Casestatus", {
        defaultValue: "Case status",
      }),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "statuscode")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "hpi_casepriority",
      label: t("HPI.CreateCase.CasePriority", {defaultValue: "Case Priority"}),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "hpi_casepriority")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "hpi_submittedbyid",
      label: t("HPI.EditCase.Case.Submittedby", {defaultValue: "Submitted By"}),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "hpi_submittedbyid")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "productserialnumber",
      label: t('HPI.ucProductInfo.pgSerialNum',{defaultValue:'Serial number'}),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "productserialnumber")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "hpi_productnumber",
      label: t('HPI.ucProductInfo.pgProductNum',{defaultValue:'Product number'}),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "hpi_productnumber")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "customerid",
      label: t("HPI.MainHomePage.grids.AccountName", {
        defaultValue: "Site-account",
      }),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "customerid")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "hpi_customertrackingnumber",
      label: t("HPI.MainHomePage.grids.InternalTrackingnumber", {
        defaultValue: "Internal Tracking number",
      }),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "hpi_customertrackingnumber")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "createdon",
      label: t("HPI.MainHomePage.grids.Datesubmitted", {
        defaultValue: "Date submitted",
      }),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "createdon")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "modifiedon",
      label: t("HPI.MainHomePage.grids.Lastupdated", {
        defaultValue: "Last updated",
      }),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "modifiedon")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },

    ];

  const favouriteColumn = [
    {
      id: "favourite",
      label: t("HPP.MainHomePage.FavoriteHeadertext", {
        defaultValue: "favourite",
      }),
      filter: (
        <Checkbox
          id="checkbox"
          checked={isChecked}
          label={t("HPI.ShowMyFavouriteCW", {
            defaultValue: "Show Favorites Only",
          })}
          onChange={(e: any) => handleOnlyFevList(e)}
        />
      ),
    },
  ];
  const columns= AdminNotIndividualRole ? [...baseTableColumn,
        // Check if the user is not an individual and has admin role
        {
          id: "hpi_bulkid",
          label: t("HPI.MainHomePage.ByCompanyTab.BulkId", {
            defaultValue: "Bulk Id",
          }),
        filter: (
          <Search
            placeholder={t("HPI.ContractWarranties.btnSearch", {
              defaultValue: "Search",
            })}
            id="table-filter-Name"
            onChange={(v) => handleSearch(v, "hpi_bulkid")}
            onClear={() => setTableFliterData(pageLoad)}
          />
        ),
      },...favouriteColumn] : [...baseTableColumn,...favouriteColumn];
  let pagedData = pagination
    ? recentcase.slice(
        (currentPage - 1) * pageSize,
        (currentPage - 1) * pageSize + pageSize
      )
    : recentcase;
  if (pagedData.length === 0) {
    pagedData = recentcase;
  }
  const paginationProps = pagination
    ? {
        currentPage,
        pageSize,
        onPageChange: (page: number) => {
          setCurrentPage(page);
        },
        totalItems: recentcase.length,
      }
    : undefined;
  const handleOnlyFevList = (e: any) => {
    setIsChecked(e.target.checked);
    handleSearch(e.target.checked, "favourite");
  };

  return (
    <>
      {progress && (
        <div className="loader-overlay">
          <div className="loader-css">
            <Loader />
          </div>
        </div>
      )}
      <div className="mb-4">
        <Row className="align-center">
          <Col md={8} className="select-container pr-0 " />
          <Col sm={4} className="button-container p-0 pt-4 justify-content-end">
            <ExportToExcelColor fileName="My Cases" rows={exportXlRow} />
          </Col>
        </Row>
      </div>
      <Table
        columns={columns}
        showFilters
        data={pagedData}
        pagination={paginationProps}
      />
    </>
  );
};
export default Recentcases;
